export interface Training {
    id: number;
    section_id: number;
    codigo: string;
    tipo: string;
    carga: number;
    descripcion: string;
    comentarios: string;
    // Estos campos se almacenan en el array values pero los usamos en el componente para facilitar la edición
    km?: number;
    th?: number;
    codigo_extra?: string;
    nota?: string;
    values: TrainingValue[];
    created_by: number;
    created_at: string;
    changed_by: number;
    changed_at: string;
}

export const emptyTraining: Training = {
    id: 0,
    section_id: 0,
    codigo: '',
    tipo: '',
    carga: 0,
    descripcion: '',
    comentarios: '',
    km: 0,
    th: 0,
    codigo_extra: '',
    nota: '',
    values: [],
    created_by: 0,
    created_at: '',
    changed_by: 0,
    changed_at: ''
}

export interface TrainingValue {
    id: number;
    training_id: number;
    value_key: string;
    value: string;
    created_by: number;
    created_at: string;
    changed_by: number;
    changed_at: string;
}

export const emptyTrainingValue: TrainingValue = {
    id: 0,
    training_id: 0,
    value_key: '',
    value: '',
    created_by: 0,
    created_at: '',
    changed_by: 0,
    changed_at: ''
}
